import { Resort } from "../types";
import styles from "../styles/HotelSearch.module.scss"
import i18n, { locale_underscore } from "../../i18n";


type ResortFilteringBarProps = {
  resorts: Resort[];
  selectedResortCodes: string[];
  handleChangeResortCodes: (resortCodes: string[]) => void;
}

const ResortFilteringBar: React.FC<ResortFilteringBarProps> = ({ resorts, selectedResortCodes, handleChangeResortCodes }) => {
  const onSelectResort = (e: React.MouseEvent<HTMLButtonElement>, resortCode: string) => {
    e.preventDefault();
    if (selectedResortCodes.some(selectedResortCodes => selectedResortCodes === resortCode)) {
      handleChangeResortCodes(selectedResortCodes.filter(selectedResortCodes => selectedResortCodes !== resortCode));
      return;
    }

    handleChangeResortCodes(selectedResortCodes.concat(resortCode));
  }
  return (
    <div className={styles.resortFilteringBarWrapper}>
      <span className={styles.resortFilteringBarTitle}>{i18n.t('stay_packages.hotels.index.filter_by_ski_resort_1')}<br />{i18n.t('stay_packages.hotels.index.filter_by_ski_resort_2')}</span>
      <div className={styles.resortItems}>
        {resorts.map(resort => {
          const isSelected = selectedResortCodes.some(selectedResortCode => selectedResortCode === resort.resort_code);
          return (
            <div className={styles.resortItem} key={`resort-filtering-bar-${resort.resort_code}`}>
              <button
                type="button"
                onClick={(e) => onSelectResort(e, resort.resort_code)}
                className={`${styles.resortFilteringButton} ${isSelected ? styles.selected : ''}`}
              >
                <img src={resort.thumb_image_url} alt="" height={36} width={36} />
                <span>{resort.localized_name[locale_underscore]}</span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ResortFilteringBar;
